<ng-container *ngIf="layout">
  <app-layout-row *ngIf="layout.type === 'row'" [layout]="layout"></app-layout-row>
  <app-layout-accordion *ngIf="layout.type === 'accordion'" [layout]="layout"></app-layout-accordion>
  <app-layout-paged-content *ngIf="layout.type === 'paged-content'" [layout]="layout"></app-layout-paged-content>
  <app-layout-tabs *ngIf="layout.type === 'tabs'" [layout]="layout"></app-layout-tabs>
</ng-container>
